import { render, staticRenderFns } from "./ActivitiesChart.vue?vue&type=template&id=92fe7960&"
import script from "./ActivitiesChart.vue?vue&type=script&lang=js&"
export * from "./ActivitiesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92fe7960')) {
      api.createRecord('92fe7960', component.options)
    } else {
      api.reload('92fe7960', component.options)
    }
    module.hot.accept("./ActivitiesChart.vue?vue&type=template&id=92fe7960&", function () {
      api.rerender('92fe7960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/activities/ActivitiesChart.vue"
export default component.exports